import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { ICustomerGenericService, IHIPGenericService, TableAction, TableHeader, TeltonikaPingFromRouterData, TeltonikaPingFromRouterStatistics, TeltonikaTracerouteData, TeltonikaTracerouteHop } from '@huge-monorepo/shared/interfaces';
import { TeltonikaFileData } from '@huge-monorepo/shared/interfaces';
import { TeltonikaPingData } from '@huge-monorepo/shared/interfaces';
import { ActivatedRoute } from '@angular/router';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { SharedGenericSingletonService, SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';
import { TeltonikaIPs } from '@huge-monorepo/shared/interfaces';
import { TeltonikaSpeedtestOption } from 'libs/shared/src/interfaces/TeltonikaSpeedtestOption';
import { TeltonikaSpeedtestData } from 'libs/shared/src/interfaces/TeltonikaSpeedtestData';

@Component({
  selector: 'huge-monorepo-teltonika-device-trouble-shooting',
  standalone: true,
  imports: [CommonModule, MatButtonModule, ToolsModule, MaterialModule],
  templateUrl: './teltonika-device-trouble-shooting.component.html',
  styleUrl: './teltonika-device-trouble-shooting.component.scss',
})
export class TeltonikaDeviceTroubleShootingComponent implements OnInit {
  teltonikaService = this.sharedTeltonikaService.getService();
  troubleshootFileData: TeltonikaFileData[];
  pingData: TeltonikaPingData | null = null;
  pingFromRouterData: TeltonikaPingFromRouterData | null = null;
  url = ``;
  opn = ``;
  imagePath?: string | null = null;
  pingFromRouterImagePath?: string | null = null;
  headers: TableHeader[] = [
    {
      ID: 'Name',
      Index: 0,
      Sort: 'Name',
      Sortable: false,
      Text: 'Name',
      Type: String,
      Align: 'left',
    },
    {
      ID: "Type",
      Index: 1,
      Sort: "Type",
      Sortable: false,
      Text: "Type",
      Type: String,
      Align: "left"
    },
    {
      ID: "Timestamp",
      Index: 2,
      Sort: "Timestamp",
      Sortable: false,
      Text: "Timestamp",
      Type: Date,
      Align: 'left'

    }
  ];
  troubleshootTableActions: TableAction[] = [
    {
      Icon: 'download',
      Text: 'Download',
      Caller: (p: TeltonikaFileData) => {
        if (p != null) {
          this.downloadTroubleshootFile(p.ID);
        }
      },
    },
  ];
  troubleshootingLoading: boolean = false;
  pingLoading: boolean = false;
  pingFromRouterLoading: boolean = false;
  pingFromRouterAddress: string | null = null;
  id: any;
  ips: TeltonikaIPs | null = null;
  selectedIp: string | null = null;
  genericService = this.sharedGenericSingletonService.getGenericService();
  tracerouteIp: string | null = null;
  tracerouteData: TeltonikaTracerouteData | null = null;
  tracerouteLoading: boolean = false;
  speedtestLoading: boolean = false;
  speedtestData: TeltonikaSpeedtestData | null = null;
  speedtestOptions: TeltonikaSpeedtestOption[] = [];
  selectedSpeedtestOption: TeltonikaSpeedtestOption | null = null;
  speedtestSocket: WebSocket | null = null;
  speedtestInProgress: boolean = false;
  isHipSuperUser: boolean = false;

  traceRouteHeaders: TableHeader[] = [
    {
      ID: 'HopNumber',
      Index: 0,
      Sort: 'HopNumber',
      Sortable: false,
      Text: 'Hop Number',
      Type: Number,
      Align: 'left',
    },
    {
      ID: "Addr",
      Index: 1,
      Sort: "Addr",
      Sortable: false,
      Text: "Address",
      Type: String,
      Align: "left"
    },
    {
      ID: "TimeTaken",
      Index: 2,
      Sort: "TimeTaken",
      Sortable: false,
      Text: "Time Taken (ms)",
      Type: Number,
      Align: 'left',
      Wrapper: (data: TeltonikaTracerouteHop) => {
        return data.TimeTaken > 0 ? data.TimeTaken : 'Timeout';
      }
    }
  ];

  speedtestHeaders: TableHeader[] = [
    {
      ID: 'Name',
      Index: 0,
      Sort: 'Name',
      Sortable: false,
      Text: 'Name',
      Type: String,
      Align: 'left',
    },
    {
      ID: "Country",
      Index: 1,
      Sort: "Country",
      Sortable: false,
      Text: "Country",
      Type: String,
      Align: "left"
    },
    {
      ID: "Sponsor",
      Index: 2,
      Sort: "Sponsor",
      Sortable: false,
      Text: "Sponsor",
      Type: String,
      Align: 'left'
    },
    {
      ID: "Distance",
      Index: 3,
      Sort: "Distance",
      Sortable: false,
      Text: "Distance (km)",
      Type: Number,
      Align: 'left'
    }
  ];

  constructor(
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private activatedRoute: ActivatedRoute,
    private sharedGenericSingletonService: SharedGenericSingletonService<ICustomerGenericService | IHIPGenericService>,
  ) { }

  ngOnInit(): void {
    let teltonikaService = this.sharedTeltonikaService.getService();
    this.isHipSuperUser = teltonikaService.isHipSuperUser();
    this.troubleshootingLoading = true;
    this.activatedRoute.paramMap.subscribe(
      (paraMap: any) => {
        if (paraMap.params.id) {
          this.id = paraMap.params.id;
          this.url = `/teltonika/${this.id}/generated`;
        }
        this.pingLoading = false;
        this.teltonikaService.getDeviceIPs(this.id).subscribe({
          next: (data) => {
            this.ips = data
            this.pingLoading = false;
          },
          error: (err) => {
            // this.db.createToast('Error', 'Failed to get device IPs', 'error');
            this.pingLoading = false;
          }
        });

        // this.fetchTroubleshootFiles();
        // this.pingDevice();
        this.troubleshootingLoading = false;
      }
    );
  }

  downloadTroubleshootFile(id: number) {
    this.teltonikaService.downloadTeltonikaFile(id).subscribe(
      {
        next: (data) => {
          return;
        },
        error: (error) => {
          this.genericService.createToast('Error', 'Failed to download backup file', 'error');
        }
      }
    );
  }

  generateTroubleshootingFile() {
    this.troubleshootingLoading = true;
    this.teltonikaService.generateFile(this.id, "troubleshoot").subscribe(
      {
        next: (data) => {
          this.opn = "&opn=true"
          // this.fetchTroubleshootFiles();
          this.troubleshootingLoading = false;
        },
        error: (err) => {

          this.troubleshootingLoading = false;
        }
      }
    );
  }

  pingDevice(ip: string | null) {
    this.pingLoading = true;
    this.selectedIp = ip;
    this.teltonikaService.pingDevice(this.id, ip).subscribe({
      next: (data: TeltonikaPingData) => {
        this.pingData = data;
        //StartTime and EndTime are epochs, convert them to valid dates & format for display
        let start: Date = new Date(this.pingData!.StartTime as number * 1000);
        let end: Date = new Date(this.pingData!.EndTime as number * 1000);
        this.pingData!.StartTime = `${start.getFullYear()}-${('0' + (start.getMonth() + 1)).slice(-2)}-${start.getDate()} ${start.getHours()}:${start.getMinutes()}:${start.getSeconds()}`;
        this.pingData!.EndTime = `${end.getFullYear()}-${('0' + (end.getMonth() + 1)).slice(-2)}-${end.getDate()} ${end.getHours()}:${end.getMinutes()}:${end.getSeconds()}`;
        if (this.pingData.Statistics.PacketsRecv > 0 && this.pingData.Statistics.PacketLoss < 100 && this.pingData.Statistics.AvgRtt > 0) {
          if (this.pingData.Statistics.AvgRtt >= 500) {
            this.imagePath = '../assets/Teltonika/Latency - High.svg';
          } else if (this.pingData.Statistics.AvgRtt >= 300) {
            this.imagePath = '../assets/Teltonika/Latency - Mid.svg';
          } else {
            this.imagePath = '../assets/Teltonika/Latency - Good.svg';
          }
        }
        this.pingLoading = false;
      },
      error: (err) => {
        this.pingData = null;
        this.pingLoading = false;
      }
    });
  }

  clear() {
    this.pingData = null;
    this.imagePath = null;
  }

  getPingColor(ping: number): string {
    if (ping >= 500) {
      return '#FFEDE9';
    } else if (ping >= 300) {
      return '#FFE3CB';
    } else if (ping > 0) {
      return '#D0FFC8';
    } else {
      return '#F0F0F0';
    }
  }

  pingFromDevice() {
    this.pingFromRouterLoading = true;
    this.pingFromRouterData = null;
    this.teltonikaService.pingFromDevice(this.id, this.pingFromRouterAddress).subscribe({
      next: (data: TeltonikaPingFromRouterData) => {
        this.pingFromRouterData = data;
        this.pingFromRouterData.Statistics = { PacketsSent: 0, PacketsRecv: 0, PacketLoss: 0, AvgRtt: 0, MaxRtt: 0, MinRtt: 0, StdDevRtt: 0 } as TeltonikaPingFromRouterStatistics;
        const rttEntries: number[] = [];
        this.pingFromRouterData.Packets.forEach(packet => {
          if (packet) {
            this.pingFromRouterData!.Statistics!.PacketsSent++;
            if (packet.Success) {
              this.pingFromRouterData!.Statistics!.PacketsRecv++;
            } else {
              this.pingFromRouterData!.Statistics!.PacketLoss++;
            }
            this.pingFromRouterData!.Statistics!.AvgRtt += packet.Rtt;
            if (this.pingFromRouterData!.Statistics!.MinRtt === 0 || packet.Rtt < this.pingFromRouterData!.Statistics!.MinRtt) {
              this.pingFromRouterData!.Statistics!.MinRtt = packet.Rtt;
            }
            if (packet.Rtt > this.pingFromRouterData!.Statistics!.MaxRtt) {
              this.pingFromRouterData!.Statistics!.MaxRtt = packet.Rtt;
            }
            rttEntries.push(packet.Rtt);
          }
        });
        if (this.pingFromRouterData!.Statistics!.PacketsSent > 0) {
          this.pingFromRouterData!.Statistics!.PacketLoss = (this.pingFromRouterData!.Statistics!.PacketLoss / this.pingFromRouterData!.Statistics!.PacketsSent) * 100;
          this.pingFromRouterData!.Statistics!.AvgRtt = this.pingFromRouterData!.Statistics!.AvgRtt / this.pingFromRouterData!.Statistics!.PacketsRecv;
          this.pingFromRouterData!.Statistics!.StdDevRtt = Math.sqrt(rttEntries.reduce((sum, rtt) => sum + Math.pow(rtt - this.pingFromRouterData!.Statistics!.AvgRtt, 2), 0) / rttEntries.length);
          this.pingFromRouterData!.Statistics!.Addr = this.pingFromRouterAddress as string;
        }

        if (this.pingFromRouterData.Statistics.PacketsRecv > 0 && this.pingFromRouterData.Statistics.PacketLoss < 100 && this.pingFromRouterData.Statistics.AvgRtt > 0) {
          if (this.pingFromRouterData.Statistics.AvgRtt >= 500) {
            this.pingFromRouterImagePath = '../assets/Teltonika/Latency - High.svg';
          } else if (this.pingFromRouterData.Statistics.AvgRtt >= 300) {
            this.pingFromRouterImagePath = '../assets/Teltonika/Latency - Mid.svg';
          } else {
            this.pingFromRouterImagePath = '../assets/Teltonika/Latency - Good.svg';
          }
        }
        this.pingFromRouterLoading = false;
      },
      error: (err) => {
        this.pingFromRouterData = null;
        this.pingFromRouterLoading = false;
      }
    });
  }

  clearPingFromDevice() {
    this.pingFromRouterData = null;
    this.pingFromRouterImagePath = null;
  }

  traceRouteIP() {
    this.tracerouteLoading = true;
    this.tracerouteData = null;
    this.teltonikaService.tracerouteFromDevice(this.id, this.tracerouteIp).subscribe({
      next: (data: TeltonikaTracerouteData) => {
        this.tracerouteData = data;
        this.tracerouteLoading = false;
      },
      error: (err) => {
        this.tracerouteData = null;
        this.tracerouteLoading = false;
      }
    });
  }

  speedTestExpanded() {
    if (this.speedtestOptions == null || this.speedtestOptions.length == 0) {
      this.getSpeedtestOptions();
    }
  }

  getSpeedtestOptions() {
    this.speedtestLoading = true;
    this.teltonikaService.getSpeedtestOptions(this.id).subscribe({
      next: (data: { options: TeltonikaSpeedtestOption[] }) => {
        this.speedtestOptions = data.options;
        this.speedtestLoading = false;
        console.log("Speedtest options:", this.speedtestOptions);
      },
      error: (err) => {
        this.speedtestOptions = [];
        this.speedtestLoading = false;
      }
    });
  }

  runSpeedtest() {
    if (this.selectedSpeedtestOption == null) {
      this.genericService.createToast('Error', 'Please select a speedtest option', 'error');
      return;
    }
    this.speedtestLoading = true;
    this.speedtestData = null;
    this.speedtestSocket = this.teltonikaService.runSpeedtest(this.id, this.selectedSpeedtestOption.Url);
    this.speedtestSocket!.onmessage = (event) => {
      const jsonObject = JSON.parse(event.data);
      this.speedtestData = jsonObject as TeltonikaSpeedtestData;
      this.speedtestLoading = false;
      this.speedtestInProgress = true;
      if (this.speedtestData.State === "FINISHED" || this.speedtestData.State === "NOT_RUNNING") {
        this.speedtestInProgress = false;
        this.speedtestSocket?.close();
      }
    };
  }

  onSpeedtestOptionSelected(event: TeltonikaSpeedtestOption) {
    this.selectedSpeedtestOption = event;
    this.runSpeedtest();
  }

  clearSpeedtest() {
    this.speedtestData = null;
    this.selectedSpeedtestOption = null;
    if (this.speedtestSocket) {
      this.speedtestSocket.close();
    }
    this.speedtestSocket = null;
  }
}

